import axios from 'axios';
import fire from '../3rd-party-config/fire';

let interceptorId = null;
let inflightTokenPromise = null;

const shouldAttachToken = (config) => {
  const hasExistingAuthHeader =
    Boolean(config?.headers?.Authorization) || Boolean(config?.headers?.authorization);
  return !hasExistingAuthHeader;
};

const getFreshIdToken = async () => {
  const user = fire.auth().currentUser;
  if (!user) {
    return null;
  }

  if (!inflightTokenPromise) {
    inflightTokenPromise = user
      .getIdToken()
      .catch(() => null)
      .finally(() => {
        inflightTokenPromise = null;
      });
  }

  return inflightTokenPromise;
};

export const installAxiosAuthInterceptor = () => {
  if (interceptorId !== null) {
    return interceptorId;
  }

  interceptorId = axios.interceptors.request.use(async (config) => {
    if (!shouldAttachToken(config)) {
      return config;
    }

    const token = await getFreshIdToken();
    if (!token) {
      return config;
    }

    const headers = config.headers || {};
    headers.Authorization = `Bearer ${token}`;
    config.headers = headers;
    return config;
  });

  return interceptorId;
};

export const uninstallAxiosAuthInterceptor = () => {
  if (interceptorId === null) {
    return;
  }

  axios.interceptors.request.eject(interceptorId);
  interceptorId = null;
};
